import { onSceneLoaded } from '../scene-load-state';

export function runOnLoadFinishedImplementation(
  _data: Record<string, unknown>,
  triggerOutPortFunctions: Map<string, () => void>
) {
  const triggerExec = triggerOutPortFunctions.get('exec')!;
  return onSceneLoaded(triggerExec);
}

/** @deprecated Use {@link runOnLoadFinishedImplementation}. */
export const runOnLoadImplementation = runOnLoadFinishedImplementation;
